import { get, post } from '@/request/request'

export default {
    list(params) {
        return get('/admin/customer/receipt/list', params)
    },
    save(params) {
        return post('/admin/customer/receipt/save', params)
    },
    delete(params) {
        return post('/admin/customer/receipt/delete', params)
    }

}